
      import {requestComponentInfo} from 'uni-platform/service/api/ui/request-component-info.js'
      export default {
        requestComponentInfo
      }
      